(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/detail-view-route-play-handler/assets/javascripts/header-bet-buttons.js') >= 0) return;  svs.modules.push('/components/tipsen/detail-view-route-play-handler/assets/javascripts/header-bet-buttons.js');
"use strict";

const useIsCurrentDrawPlayable = svs.components.tipsen.hooks.useIsCurrentDrawPlayable;
const CouponBetButtons = svs.components.tipsen.couponBetButtons.CouponBetButtons;
const useCurrentDrawEvent = svs.components.tipsen.drawProvider.hooks.useCurrentDrawEvent;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const selectIsReduceSystemChosen = svs.components.tipsen.engine.selectors.couponSelectors.selectIsReduceSystemChosen;
const getOutcomeLabelsForEventType = svs.components.sport.tipsenShared.getOutcomeLabelsForEventType;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const HeaderBetButtons = () => {
  const couponId = useCouponId();
  const event = useCurrentDrawEvent();
  const draw = useCurrentDraw();
  const eventTypeId = event === null || event === void 0 ? void 0 : event.eventTypeId;
  const isApprovedEventType = eventTypeId === EventTypeId.EVENT_1X2 || eventTypeId === EventTypeId.HEAD_TO_HEAD || eventTypeId === EventTypeId.GOAL_COUNT;
  const isDrawPlayable = useIsCurrentDrawPlayable();
  const isReduceSystem = useSelector(state => selectIsReduceSystemChosen(state, couponId));
  if (isReduceSystem || !isApprovedEventType || !couponId) {
    return null;
  }
  const outcomeLabels = getOutcomeLabelsForEventType(eventTypeId, draw === null || draw === void 0 ? void 0 : draw.sportType);
  const outcomes = outcomeLabels.map(el => el.text);
  return React.createElement(CouponBetButtons, {
    board: 0,
    couponId: couponId,
    event: event.eventNumber - 1,
    hasDisabledBets: !isDrawPlayable,
    outcomeLabels: outcomeLabels,
    outcomes: outcomes
  });
};
setGlobal('svs.components.tipsen.detailViewRoutePlayHandler.HeaderBetButtons', HeaderBetButtons);

 })(window);